export default __webpack_public_path__ + "static/media/021-radar-1.6505bdb4.png";